<template>
  <modal.ControlledModal closeable @close="closeModal">
    <div :class="$style.viewer">
      <iframe :class="$style.viewer__content" v-if="fileUrl" :src="fileUrl" />
      <LoadingIndicator v-else />
    </div>
  </modal.ControlledModal>
</template>

<script setup lang="ts">
import { watch } from 'vue'
import { useModal } from '@/hooks/useModal'
import LoadingIndicator from '@/components/atoms/LoadingIndicator.vue'

const props = defineProps<{
  isOpened: boolean
  fileUrl: string | null
}>()

const emit = defineEmits<{
  (event: 'close'): void
}>()

const modal = useModal()

const closeModal = () => {
  modal.closeModal()
  emit('close')
}

watch(
  () => props.isOpened,
  isOpened => {
    if (isOpened) {
      modal.openModal()
    } else {
      closeModal()
    }
  }
)
</script>

<style lang="scss" module>
.viewer {
  width: 90vw;
  height: 90vh;
  display: flex;
  justify-content: center;
  align-items: center;

  &__content {
    width: 90vw;
    height: 90vh;
  }
}
</style>
